<template>
  <nav>
    <nav-toolbar
      :user="user"
      @toggle-drawer="drawer = !drawer"
      @logout="handleLogout"
      @open-login="loginDialog = true"
      @open-register="registrationDialog = true"
    />
    
    <nav-drawer
      v-model="drawer"
    />

    <login-dialog
      v-model="loginDialog"
      @open-register="openRegistrationFromLogin"
    />

    <temp-register-dialog
      v-model="registrationDialog"
    />
  </nav>
</template>

<script>
import { ref, getCurrentInstance, defineComponent } from 'vue'
import NavToolbar from './nav/NavToolbar.vue'
import NavDrawer from './nav/NavDrawer.vue'
import LoginDialog from './nav/LoginDialog.vue'
import TempRegisterDialog from './nav/TempRegisterDialog.vue'
import axios from '../plugins/axios'

export default defineComponent({
  name: "NavBar",
  components: {
    NavToolbar,
    NavDrawer,
    LoginDialog,
    TempRegisterDialog
  },
  props: {
    user: {
      type: String,
      default: null
    }
  },
  setup(props, { emit }) {
    const instance = getCurrentInstance()
    const router = instance.proxy.$router

    // State management with refs
    const drawer = ref(false)
    const loginDialog = ref(false)
    const registrationDialog = ref(false)

    // Logout handler
    const handleLogout = async () => {
      try {
        const userId = localStorage.getItem("userId")
        const sessionToken = localStorage.getItem("sessionToken")

          await axios.get(`/v1/logout`, {
              headers: {
                  'Content-Type': 'application/json',
                  'userId': userId,
                  'sessionToken': sessionToken
              }
          })
      } catch (error) {
        console.error('Error logging out:', error)
      } finally {
        localStorage.removeItem("userId")
        localStorage.removeItem("sessionToken")
        emit("logout", true)
        router.push('/')
      }
    }

    // Handler to switch from login to registration dialog
    const openRegistrationFromLogin = () => {
      loginDialog.value = false;
      registrationDialog.value = true;
    };

    return {
      drawer,
      loginDialog,
      registrationDialog,
      handleLogout,
      openRegistrationFromLogin
    }
  }
});</script>